import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { AudienceResult } from "./types";

/**
 * POST /api/campaigns/{id}/audience — freeze APPROVED leads into the audience
 * snapshot. Suppression re-runs fail-closed at this gate. Invalidates the
 * campaigns list on success (status/metrics can change).
 */
export function useFreezeAudience(campaignId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      httpClient<AudienceResult>(`/api/campaigns/${campaignId}/audience`, { method: "POST" }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["campaigns"] }),
  });
}
